exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-option{float:left;border-radius:4px;margin-right:15px;display:block;padding:7px 12px 8px}.form-option,.form-option *{cursor:pointer}.form-option label{font-weight:400;margin:0}.form-option label input[type=radio]{margin:0;vertical-align:middle}.form-option:hover{background:#eee}.form-option.selected{color:#fff!important;background:#246788!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/Modules/FormOption/FormOption.less
 ** module id = 1062
 ** module chunks = 0
 **/